<template>
  <div id="content" class="internalAssessment previewNewAssessment">
    <div class="container">
      <div class="internalAssessment_nav" v-if="internalAssessment">
        <div class="navigationVotes">
          <div class="one13">
            <router-link v-if="internalAssessment.judges" class="assessjudge-prev-button" :to="'/'+backUrlbase()+'/'+internalAssessment.judges.accessToken.$oid+'/'+internalAssessment._id.$oid+'?step=1'">
             <span>{{$t("Back to the list")}}</span>
           </router-link>
          </div>

            <div class="list one13">
              <img :src="require('@/assets/assessDone.svg')" v-show="votes.is_submit==true" alt=""/>
              <div  class="innopearl_input select3211234"  @click="this.$refs.listStartupToAssessSelect.focus();">
                <select ref="listStartupToAssessSelect" v-model="vote_for" @change="loadVote($event)">
                  <option v-for="(startup, p ) in internalAssessment.startups " :key="p" :value="startup._id.$oid">{{startup.name}}</option>
                </select>
              </div>
            </div>
            <div class="nextStartup one13">
              <button v-show="getNextStartup() != null" class="assessjudge-next-button" @click="loadVote2(getNextStartup())">

               <span>{{$t("Next innovator")}}</span>

             </button>
            </div>
        </div>
      </div>
            <div class="internalAssessment_inner mt20" v-if="internalAssessment">
        <div class="internalAssessmentContent2Col ">
          <div class="row flexRow">
            <div class="col-12 col-xl-6">
              <div class="startup" v-if="startup">
                <div class="headerStartup">
                  <span class="startupName">{{startup.name}}<span v-if="startup.name.charAt(startup.name.length - 1)">'s</span><span v-else>'</span> profile</span>

                </div>
                <div class="keyContact">
                  <StartupContact :startup="startup"/>

                </div>

                <div class="startupInfo">
                  <StartupInfoLine v-if="startup.company_type" name="Company type" :value="startup.company_type" />
                  <StartupInfoLine v-else name="Company type" value="No data" />

                  <StartupInfoLine v-if="startup.application_area" class="" className="" name="Application domain" :value="startup.application_area"  :isArray="Array.isArray(startup.application_area)"/>

                  <StartupInfoLine v-if="startup.value_proposition" class="" className="" name="Value proposition" :value="startup.value_proposition"  :isArray="Array.isArray(startup.value_proposition)"/>

                  <StartupInfoLine v-if="startup.solution" name="solution" className="" class="" :value="startup.solution"/>

                  <StartupInfoLine v-if="startup.funding_stage" name="Funding stage" className="" class="" :value="startup.funding_stage"/>

                  <StartupInfoLine v-if="startup.no_revenue_yet" class="" className="" name="Revenue" value="No revenue yet" />
                  <StartupInfoLine v-else-if="startup.revenue?.value" class="" className="" name="Revenue" :value="startup.revenue" :isCurrency="true"/>

                  <StartupInfoLine v-if="startup.team_size" class=""  className="" name="Team size" :value="startup.team_size"/>

                  <StartupInfoLine v-if="startup.location" class="" className="" name="Location" :isLocation="true" :value="startup.location" :isArray="Array.isArray(startup.location)"/>


                  <StartupInfoLine :noCutter='true' v-if="startup.website" name="Website" :value="startup.website" :isUrl="true"/>
                  <StartupInfoLine :noCutter='true' v-if="startup.company_founded_year" name="Foundation year" :value="startup.company_founded_year"/>
                  <StartupInfoLine :noCutter='true' v-if="startup.location" name="Location" :isLocation="true" :value="startup.location" :isArray="Array.isArray(startup.location)"/>
                  <StartupFounders v-if="isThereFounders(startup.founders)" :founders="startup.founders" label="founders"/>

                  <StartupInfoLine :noCutter='true' v-if="startup.linkedin_profile" name="Linkedin profile" :value="startup.linkedin_profile" :isUrl="true"/>

                  <StartupInfoLine :noCutter='true'  name="Woman co-founder" :value="startup.woman_cofounder" :isBoolean="true"/>
                  <StartupInfoLine :noCutter='true' v-if="startup.IP" name="ip" :value="startup.IP" :isArray="Array.isArray(startup.IP)"/>
                  <StartupInfoLine :noCutter='true' v-if="startup.skills" name="Skills" :value="startup.skills" :isArray="Array.isArray(startup.skills)"/>
                  <StartupInfoLine :noCutter='true' v-if="startup.assets" name="Assets" :value="startup.assets" :isArray="Array.isArray(startup.assets)"/>

                  <StartupInfoLine :noCutter='true' v-if="startup.product_category" name="Innovation category" :value="startup.product_category" :isArray="Array.isArray(startup.product_category)"/>
                  <StartupInfoLine :noCutter='true' v-if="startup.innovation_area" name="Innovation Area" :value="startup.innovation_area" :isArray="Array.isArray(startup.innovation_area)"/>

                  <!-- NEW FIELD -->
                  <StartupInfoLine :noCutter='true' v-if="startup.data_available" name="Data available" :value="startup.data_available" :isArray="Array.isArray(startup.data_available)"/>

                  <StartupInfoLine :noCutter='true' v-if="startup.regulatory_status" name="Regulatory status" :value="startup.regulatory_status"/>
                  <StartupInfoLine :noCutter='true' v-if="startup.patents" name="Patents granted/applied" :value="startup.patents"/>
                  <StartupInfoLine :noCutter='true' v-if="startup.other_protections" name="Other forms of protection" :value="startup.other_protections"/>



                  <StartupInfoLine :noCutter='true' v-if="startup.sustainability_impact" name="Sustainability impact" :value="startup.sustainability_impact" :isArray="Array.isArray(startup.sustainability_impact)"/>
                  <StartupInfoLine :noCutter='true' v-if="startup.key_benefits" name="Key benefits" :value="startup.key_benefits" :isArray="Array.isArray(startup.key_benefits)"/>

                  <StartupInfoLine :noCutter='true' v-if="startup.key_benefits_kpi" name="Solution's KPIs" :value="startup.key_benefits_kpi" />
                  <StartupInfoLine :noCutter='true' v-if="startup.pitchdeck_link" name="Link to presentation deck" :value="startup.pitchdeck_link" :isUrl="true"/>

                  <StartupInfoLine :noCutter='true' v-if="startup.presentation_deck_file" name="Presentation deck file" :value="this.apiUrl+'/get_public_file/'+startup.presentation_deck_file._id.$oid" displayedAs="View presentation deck file" :isUrl="true"/>
                  <StartupInfoLine :noCutter='true' v-if="startup.TRL" name="TRL" :value="startup.TRL"/>
                  <StartupInfoLine :noCutter='true' name="Full brand" :value="startup.full_brand" :isBoolean="true"/>

                  <StartupInfoLine :noCutter='true' v-if="startup.development_stage" name="Development stage" :value="startup.development_stage"/>
                  <StartupInfoLine :noCutter='true' v-if="startup.funding_stage" name="Funding stage" :value="startup.funding_stage"/>
                  <!-- <StartupInfoLine :noCutter='true' v-if="startup.last_funding_round" name="Last funding round" :value="startup.last_funding_round" :isCurrency="true"/> -->
                  <StartupInfoLine :noCutter='true' v-if="startup.investors" name="Investors" :value="startup.investors"/>

                  <StartupInfoLine :noCutter='true' v-if="startup.markets" name="Served markets" :value="startup.markets" :isArray="Array.isArray(startup.markets)"/>
                  <div v-if="startup.investment_raised">
                    <StartupInfoLine :noCutter='true' v-if="startup.investment_raised.value" name="investment raised" :value="startup.investment_raised" :isCurrency="true"/>

                  </div>
                  <StartupInfoLine :noCutter='true' v-if="startup.main_clients" name="Reference customers " :value="startup.main_clients" />
                  <StartupInfoLine :noCutter='true' v-if="startup.business_model" name="Business model" :value="startup.business_model" :isArray="Array.isArray(startup.business_model)"/>
                  <StartupInfoLine :noCutter='true' v-if="startup.paying_customers" name="Paying customers" :value="startup.paying_customers" :isBoolean="true"/>
                  <StartupInfoLine :noCutter='true' v-if="startup.market_validation" name="Market fit evidence" :value="startup.market_validation" :isBoolean="true"/>

                  <StartupInfoLine :noCutter='true' v-if="startup.market_potential" name="Market potential" :value="startup.market_potential" :isCurrency="true"/>
                  <StartupInfoLine :noCutter='true' v-if="startup.partnership_objectives" name="partnership objectives" :value="startup.partnership_objectives" :isArray="Array.isArray(startup.partnership_objectives)"/>


                </div>

              </div>
            </div>
            <div class="col-12 col-xl-6">
              <div class="criterias">

                <span class="mainColTitle">{{ $t("Assessment criteria")}}</span>
                <div class="criteriaList">
                  <div class="oneCriteria" v-for="(criteria,c) in votes.criteriasVote" :key="c">
                    <div class="criteriaHead">
                      <div class="criteriaNameAndIcon">
                        <span class="criteriaName">{{criteria.criteriaItem.name}}</span>
                        <v-img :src="require('@/assets/infoCriteria.svg')" @click="toggleDetailsSelected(c)" alt=""></v-img>
                        <CriteriaDetails v-click-outside="hideDetails" :hideGroup="true" :criteria="criteria.criteriaItem" :criteriaGroups="criteriaGroups" :hideEdit="true" v-if="showDetailsIndexInSelected === c"/>
                      </div>
                      <div class="dontGiveAValue">
                        <label :for="'selectAllFav'+c"  class="selectIt" @click="criteria.notknown = !criteria.notknown;criteria.vote=-1;">
                          <input class="checkbox__input" type="checkbox" value="true" :id="'selectAllFav'+c"  v-model="criteria.notknown">
                          <span class="criteriaName" @click="criteria.notknown = !criteria.notknown;criteria.vote=-1;">{{ $t("I can’t assess")}}</span>
                        </label>
                      </div>
                    </div>
                    <div class="criteriaVoting">

                      <div class="myslider">
                        <v-slider v-model="criteria.vote" min="1" max="5" step="1" thumb-size="30" thumb-label="always" @end="criteria.notknown=false" color="#3982C4">
                          <template v-slot:prepend><span class="vsliderIndicator">1</span></template>
                          <template v-slot:append><span class="vsliderIndicator">5</span></template>

                        </v-slider>
                      </div>


                    </div>


                  </div>
                </div>
                <div class="feedBacks" v-if="!internalAssessment.disableFeedback">
                  <div class="row">
                    <div class="col-12 col-xl-12 zone_input" v-if="internalAssessment.feedback_1">
                      <div class="zone_input_header">
                        <span class="zone_input_name">{{ internalAssessment.feedback_1 }}</span>
                      </div>
                      <textarea class="innopearl_input"  v-model="votes.feedback_1"/>
                    </div>
                    <div class="col-12 col-xl-12 zone_input" v-if="internalAssessment.feedback_2">
                      <div class="zone_input_header">
                        <span class="zone_input_name">{{ internalAssessment.feedback_2 }}</span>
                      </div>
                      <textarea  class="innopearl_input"  v-model="votes.feedback_2"/>
                    </div>
                    <div class="col-12 zone_input" v-if="internalAssessment.feedback_3">
                      <div class="zone_input_header">
                        <span class="zone_input_name">{{ internalAssessment.feedback_3 }}</span>
                      </div>
                      <textarea  class="innopearl_input"  v-model="votes.feedback_3"/>
                    </div>

                  </div>

                </div>
                <div class="feedBacks" v-else>
                  <div class="col-12 zone_input" >
                    <div class="zone_input_header">
                      <span class="zone_input_name">Comments</span>
                    </div>
                    <textarea  class="innopearl_input"  v-model="votes.comments"/>
                  </div>
                </div>

                <div class="interest">
                  <div class="flex">
                    <div class="barLabel">
                      <span>{{ $t("Overall interest")}}</span>
                    </div>
                    <div class="barcontainer">
                      <div :class="'bar '+votes.collab_interest_level">
                      </div>
                      <div class="jauge" >
                          <label for="low" class="jauge_label low">
                            <input type="radio" id="low" value="low" v-model="votes.collab_interest_level"  />
                            <div class="info">
                              <span>{{ $t("Low")}}</span>
                              <small>{{ $t("No Interest")}}</small>
                            </div>
                          </label>
                          <label for="medium"  class="jauge_label medium">
                            <input type="radio" id="medium" value="medium" v-model="votes.collab_interest_level" />
                            <div class="info">
                              <span>{{ $t("Medium")}}</span>
                              <small>{{ $t("Consider for later")}}</small>
                            </div>
                          </label>
                          <label for="high"  class="jauge_label high">
                            <input type="radio" id="high" value="high" v-model="votes.collab_interest_level" />
                            <div class="info">
                              <span>{{ $t("High")}}</span>
                              <small>{{ $t("Progress now")}}</small>
                            </div>

                          </label>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="actions" v-if="editOk == true">
                  <button v-if="!votes.is_submit" type="button" class="prev_step_btn_small" @click='save' name="button">{{$t("Save & review later")}}</button>

                   <button type="button" class="next_step_btn_small" @click='submit' name="button">{{$t("Submit")}}</button>
                </div>
              </div>
            </div>

          </div>
        </div>

    </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
// import { QuillEditor } from '@vueup/vue-quill'
// import '@vueup/vue-quill/dist/vue-quill.snow.css';
import StartupInfoLine from '@/components/InfoStartupLine.vue'
//
// //import { Toaster, toast } from 'vue-sonner'
// import CreateCriteriaModal from '@/components/modals/createCriteria.vue'
 import CriteriaDetails from '@/components/CriteriaDetail.vue'
 import StartupContact from '@/components/StartupContact.vue'

 // import api from '../tools/api';
 import { toast } from 'vue-sonner'
export default {
  components: {
    // QuillEditor,
    // CreateCriteriaModal,
    StartupContact,
    CriteriaDetails,
    StartupInfoLine
  },
  name: 'InternalAssessmentPreview',
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      dialog:false,
      pageInfo: {
        mainTitle : "My assessment space ",
        subTitle : this.$t("Preview"),
      },
      editOk: true,
      demoValue:[],
      demoDisable:[],
      showSidePanelBasic: false,
      showDetailsIndexInSelected:null,
      showDetailsIndexInFav:null,
      internalAssessment : {
        startups:[]
      },
      votes: {
        criteriasVote : [],
        feedback_1 : '',
        feedback_2 : "",
        feedback_3 : "",
        comment:"",
        collab_interest_level : "medium",
      },
      vote_for:null,
      deadlineDateFormated: "",
      startup : {
        name:"",
        startup_datapolicy_ok: false,
        revenue: {
          unit:null,
          currency: null,
          value:null,
        },
        investment_raised: {
          unit:null,
          currency: null,
          value:null,
        },
        targeted_segements: [],
        partnership_objectives: [],
      },
      criteriaGroups: []

    }
  },
  methods:{
    backUrlbase(){
      if(this.internalAssessment.judges.licenced == true){
        return 'do_assessment';
      }
      else{
        return 'judge_assessment';
      }
    },
    getNextStartup(){
    var index = this.internalAssessment.startups.findIndex(item => item._id.$oid == this.vote_for);
      if (index !== -1 && index < this.internalAssessment.startups.length - 1) {
       var s = this.internalAssessment.startups[index + 1];
       return s._id.$oid;
     } else {
       // If no next item or item not found, return null or undefined
       return null;
     }
   },
   loadVote2(newId){
     this.votes.criteriasVote = [];
     this.axios.get(process.env.VUE_APP_API_URL+"/judgeAssessmentVote/"+this.$route.params.token+"/"+this.$route.params.id+"/"+newId).then( (r) => {

       console.log("v",this.votes);
       if(r.data.votes){
         console.log("votes",r.data.votes);
         this.votes = r.data.votes
       }
       else{
         this.votes = {
           criteriasVote : [],
           feedback_1 : '',
           feedback_2 : "",
           feedback_3 : "",
           comments:"",
           collab_interest_level : "medium",
         };
       }

       this.internalAssessment.criterias.forEach((item) => {
         if(!r.data.votes)this.votes.criteriasVote.push({vote: 3,notknown : false, criteria_id : item.$oid, criteriaItem:item});
       });

     }).catch( () => {
         toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
     });
     this.vote_for = newId;
     this.startup = {
       name:"",
       startup_datapolicy_ok: false,
       revenue: {
         unit:null,
         currency: null,
         value:null,
       },
       investment_raised: {
         unit:null,
         currency: null,
         value:null,
       },
       targeted_segements: [],
       partnership_objectives: [],
     };
     this.axios.get(process.env.VUE_APP_API_URL+"/startup_for_judge/"+this.vote_for).then( (r) => {
       var temp = _.merge(this.startup, r.data)
       this.startup = temp;

       console.log(this.startup);
    }).catch( () => {
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
    });
  },
    loadVote(event){
      console.log("vote change");
      var newId = event.target.value;
      this.votes.criteriasVote = [];
      this.axios.get(process.env.VUE_APP_API_URL+"/judgeAssessmentVote/"+this.$route.params.token+"/"+this.$route.params.id+"/"+newId).then( (r) => {

        console.log("v",this.votes);
        if(r.data.votes){
          console.log("votes",r.data.votes);
          this.votes = r.data.votes
        }
        else{
          this.votes = {
            criteriasVote : [],
            feedback_1 : '',
            feedback_2 : "",
            feedback_3 : "",
            comments :"",
            collab_interest_level : "medium",
          };
        }

        this.internalAssessment.criterias.forEach((item) => {
          if(!r.data.votes)this.votes.criteriasVote.push({vote: 3,notknown : false, criteria_id : item.$oid, criteriaItem:item});
        });

      }).catch( () => {
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });
      this.vote_for = newId;
      this.startup = {
        name:"",
        startup_datapolicy_ok: false,
        revenue: {
          unit:null,
          currency: null,
          value:null,
        },
        investment_raised: {
          unit:null,
          currency: null,
          value:null,
        },
        targeted_segements: [],
        partnership_objectives: [],
      };
      this.axios.get(process.env.VUE_APP_API_URL+"/startup_for_judge/"+this.vote_for).then( (r) => {
        var temp = _.merge(this.startup, r.data)
        this.startup = temp;

        console.log(this.startup);
     }).catch( () => {
         toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
     });
   },
    getGroupNameById(id) {
      console.log("search id:",id);
      console.log(this.criteriaGroups);
      var group = this.criteriaGroups.find(g => g._id.$oid == id.$oid);
      console.log("dinf ",group);
      return group ? group.name : null; // Return the groupname or null if not found
    },
    toggleDetailsSelected(index) {
      if (this.showDetailsIndexInSelected === index) {
        this.showDetailsIndexInSelected = null; // Hide if already visible
      } else {
        this.showDetailsIndexInSelected = index; // Show the clicked index
        this.showDetailsIndexInFav = null; // Hide if already visible
        this.showDetailsIndexInAvailable = null; // Hide if already visible
        this.showDetailsGroupIndexInAvailable = null;
      }
    },
    hideDetails(){
      this.showDetailsIndexInFav = null; // Hide if already visible
      this.showDetailsIndexInSelected = null;
      this.showDetailsIndexInAvailable = null; // Hide if already visible

    },
    isThereFounders(f){
      if(f == null){
        return false;
      }
      else if(f.length > 0){
        return true;
      }
      else{
        return false;
      }
    },
    founderLink: function(link){
      if(link){
        if(link.startsWith("https://")){
          return link;
        }
        else{
          return "https://"+link;
        }
      }
      else{
        return null;
      }

    },
    save(){
      var postdata = {
        vote : this.votes,
        assessment: this.internalAssessment._id.$oid,
        startup: this.startup._id.$oid,
        token : this.internalAssessment.judges.accessToken.$oid
      }
      this.axios.post(process.env.VUE_APP_API_URL+"/judge_save_vote",
        postdata,
        { headers: {'Content-Type': 'application/json',}}
      ).then( (r) => {
          console.log("criteriaGroups",r.data);
          console.log(r);
          toast.success(this.$t("Your entries have been saved!"));

        }).catch( (e) => {
          console.log(e);
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
    },
    submit(){
      var postdata = {
        vote : this.votes,
        assessment: this.internalAssessment._id.$oid,
        startup: this.startup._id.$oid,
        token : this.internalAssessment.judges.accessToken.$oid
      }
      this.axios.post(process.env.VUE_APP_API_URL+"/judge_submit_vote",
        postdata,
        { headers: {'Content-Type': 'application/json',}}
      ).then( () => {
          this.votes.is_submit = true;
          toast.success(this.$t("Your assessment has been submitted. You can modify and re-submit any time before the deadline."));

        }).catch( (e) => {
          console.log(e);
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
    }
},
  mounted(){
    this.dict_loaded = false;
    if(this.$route.params.token != "undefined" && this.$route.params.id!= "undefined" && this.$route.params.sid != "undefined"){
      this.axios.get(process.env.VUE_APP_API_URL+"/judgeAssessmentVote/"+this.$route.params.token+"/"+this.$route.params.id+"/"+this.$route.params.sid).then( (r) => {
        this.internalAssessment = r.data.assessment;
        this.votes.criteriasVote = [];
        console.log("ia",this.internalAssessment);
        this.criteriaGroups = [];
        var groups_founded = [];
        if(this.internalAssessment.deadline){

          this.deadlineDateFormated = this.internalAssessment.deadline.date.split(' ')[0];
        }

        const today = new Date().toISOString().split('T')[0];


        if (this.deadlineDateFormated > today && this.internalAssessment.status == 'progress') {
          this.editOk = true;
        } else {
            this.editOk = false;
        }

        console.log("v",this.votes);
        if(r.data.votes){
          console.log("votes",r.data.votes);
          this.votes = r.data.votes
        }
        this.internalAssessment.criterias.forEach((item) => {
          if(!r.data.votes)this.votes.criteriasVote.push({vote: 3,notknown : false, criteria_id : item.$oid, criteriaItem:item});
          if(Array.isArray(item.group)){
            item.group.forEach((g) => {
              if (!groups_founded.includes(g.$oid)) {groups_founded.push(g.$oid);}
            });

          }
          else {
            if (!groups_founded.includes(item.group.$oid)) {groups_founded.push(item.group.$oid);}
          }
        });
        if(groups_founded.length > 0){
            this.axios.post(process.env.VUE_APP_API_URL+"/getGivenGroups",
              {
                groups_founded :groups_founded,
              },
              { headers: {'Content-Type': 'application/json',}}
            ).then( (r) => {
                console.log("criteriaGroups",r.data);
                this.criteriaGroups = r.data

              }).catch( (e) => {
                console.log(e);
                toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
              });
        }



      }).catch( () => {
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });
            this.vote_for = this.$route.params.sid;
      this.axios.get(process.env.VUE_APP_API_URL+"/startup_for_judge/"+this.$route.params.sid).then( (r) => {
        var temp = _.merge(this.startup, r.data)
        this.startup = temp;

        console.log(this.startup);
     }).catch( () => {
         toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
     });
   }
    this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)

     // api.get(process.env.VUE_APP_API_URL+"/restrict/mycriteriabygroup").then( (r) => {
     //   this.criteriaGroups = r.data;
     //   console.log("criterias : ",r.data);
     //   console.log(r);
     // }).catch( (e) => console.log(e));

  },
  computed:{

},
watch:{

}

}
</script>
<style media="screen" scoped>
.internalAssessment{
  padding-top:50px;
  padding-bottom:50px;
}
.internalAssessment_nav{
    padding: 25px 50px;
    border-radius:20px;
    background: #FFF;
    background: #FFFFFF 0% 0% no-repeat padding-box;
}

.internalAssessment_inner{
    padding: 50px;
    padding-top:25px;
    border-radius:20px;
    background: #FFF;
    background: #FFFFFF 0% 0% no-repeat padding-box;
}

.assessment-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    width: 100%;
        background-color: #fbfbfb;
        padding:20px;
}

.assessjudge-prev-button {
    color: #3783C5;
    background: # 0% 0% no-repeat padding-box;
    padding: 10px 20px;
    border: none;
    display: flex;
    align-items: center;
        cursor: pointer;
        gap:5px;
        border-radius: 200px;
        border:1px solid #3783C5;
}
.assessjudge-next-button {
    color: #fff;
      border:1px solid #3783C5;
    background: #3783C5 0% 0% no-repeat padding-box;
        padding: 10px 20px;
    border: none;
    display: flex;
    align-items: center;
        cursor: pointer;
        border-radius: 200px;
}



  .status{
    gap:5px;
  }
  .status.inprogress {
      display: flex;
      align-items: center;
      background-color: #FFAA2A;
        padding: 5px 20px !important;
      border-radius: 15px;
  }

  .status.inprogress .status-text {
      color: #fff;
      font-size: 14px;
  }
  .status.draft {
      display: flex;
      align-items: center;
      background-color: #6C68A2;
        padding: 5px 20px !important;
      border-radius: 15px;
  }


  .status.draft .status-text {
      color: #fff;
      font-size: 14px;
  }

  .status.completed {
      display: flex;
      align-items: center;
      background-color: #4ADE80;
        padding: 5px 20px !important;
      border-radius: 15px;
  }

  .status.completed .status-text {
      color: #FFF;
      font-size: 14px;
  }


  .status.closed {
      display: flex;
      align-items: center;
      background-color: #ADB3B5;
        padding: 5px 20px !important;
      border-radius: 15px;
  }

  .status.closed .status-text {
      color: #fff;
      font-size: 14px;
  }
.next-button .v-img{
  margin-left:10px;
}

.left{

  flex: 1;
  display: flex;
  align-items: center;
  gap: 20px;
}
@media screen and (max-width:990px){
  .assessment-navigation{
    flex-direction: column;
        align-items: left;
    gap:20px;
    padding: 10px;
  }

  .left {
    flex-wrap: wrap;
  }
}
.oneInfoAboutTitle{
  font-size:14px;
  font-weight:700;
  color:#000;
}
.mainColTitle{
  color:rgba(4, 36, 106, 1);
  font-size:20px;
  font-weight: 700;
}
.internalAssessmentContent2Col .criterias,
.internalAssessmentContent2Col .startup{
  padding:20px;
  border:1px solid rgba(55, 131, 197, 1);
  border-radius:20px;
}


.criteriaList{
  display:flex;
  flex-direction: column;
  gap:20px;
  margin-top:20px;
}
.criteriaNameAndIcon{
  display:flex;
  gap:10px;
  position:relative;
}
.oneCriteria .criteriaHead{
  display:flex;
  gap:10px;
  position:relative;
  justify-content: space-between;
}
.oneCriteria .criteriaHead .criteriaName{
  font-weight: 700;
  font-size:14px;
  color:rgba(10, 32, 113, 1);
}
.criteriaName{
  font-weight: 700;
  font-size:14px;
  color:rgba(10, 32, 113, 1);
}
.criteriaHead .v-img{
  width:18px;
  flex:none;
}

.vsliderIndicator{
  font-size:15px;
  font-weight: 500;
  color:#3783C5;
}
.selectIt{


display:flex;
align-items: center;
gap: 10px;
}
.selectIt input{
  width:24px;
  height:24px;
}

.criteriaVoting{
  display:flex;
  gap:20px;
  align-items: center;
}
.criteriaVoting .myslider{
  width:100%;
}


.zone_input_name{
  text-align: left;
  font-size: 18px;
  line-height: 21px;
  color: rgba(4, 36, 106, 1);
  font-weight: 600;
}
.zone_input_header{
  display:flex;
  gap: 10px;
  position:relative;
}

.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
box-sizing: border-box;
height: 40px;
padding: 5px;
width:100%;
}
@media screen and (max-width: 990px){
.innopearl_input{
  width:100%;
  margin-left:0;
}
}

textarea.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
margin-top:20px;
margin-bottom: 20px;
padding: 5px;
 resize: none;
 height:60px;

}

.interest,
.feedBacks{
  margin-top:50px;
  border-top:1px solid #125AA433;
  padding-top:50px;
  margin-bottom: 50px;
}

.internalAssessmentContent2Col{
  margin-top:50px;
}


.selectedStartups{
  margin-top:50px;
  padding:50px;
  background:rgba(245, 250, 255, 1);
  border-radius: 15px;
}
.selectedStartups .titleText{
  font-size:20px;
  font-weight: 700;
  text-align:center;
  color:rgba(4, 36, 106, 1);
}



  .selectCandidateCard{
    background:#FFF;
  }
  .selectCandidateCard  .candidate_card_head{
      color: #4c81c0;
      padding: 10px 0px;
      background: #FFF;
      text-transform: uppercase;
      font-weight: bold;
    margin-left: 20px;
    margin-right: 20px;
      display:flex;
      align-content: center;
        align-items: center;
    gap:10px;
    min-height: 60px;

  }
  .candidate_card_head .name{
    flex:1;
  }
.candidate{
  margin-top:20px;
  margin-bottom: 20px;
}
.candidate_card{
  border: 2px solid #DDDDDD;
border-radius: 15px;
z-index: 5;
height:100%;
display: flex;
flex-direction: column;
}
.candidate_card .candidate_image{
  width:100%;
  height:200px;
  object-fit: cover;
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.clickable{
  cursor:pointer;
}
.candidate_card .candidate_links{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px 5px;

  margin: 0;
}
.candidate_card .candidate_info_content{
  padding:10px 20px ;
  flex-grow: 1;
}
.candidate_card .candidate_info_content .candidate_name{
  font-size:18px;
  line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;
}

.candidate_card .candidate_info_content .candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_card .candidate_links .details{
  font-size:12px;
  line-height: 15px;
  border-right: 1px solid #DDD;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
  flex: 0.5;

}
.candidate_card .candidate_links .details a{
    text-decoration: none;
}
.candidate_card .candidate_links .details img{
  margin-right:5px;
}
.candidate_card .candidate_links .selectIt{
  font-size:12px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  flex:0.5;
  align-items: flex-end;

}

.candidate_card .candidate_links .selectIt_fw{
  flex:1;
  align-items: flex-start;
}
.candidate_card .candidate_links .selectIt_fw label{
display:flex;
align-items: center;
gap: 5px;
justify-content: start;
}
.candidate_card .candidate_links .selectIt label{
display:flex;
align-items: center;
gap: 5px;
justify-content: end;
}
.candidate_card .candidate_links .selectIt input{
  width:24px;
  height:24px;
}
.candidate_card .candidate_links .details.noBorder{
  border-right: none;

}

  .candidate_card_head{
    background: transparent linear-gradient(270deg, #3783C5 0%, #1368B2 100%) 0% 0% no-repeat padding-box;

    padding: 10px;
    color: #FFF;
    text-transform: uppercase;
    font-weight: bold;
    border-radius: 10px 10px 0px 0px;
    display:flex;
    align-content: center;
      align-items: center;
  gap:10px;
  min-height: 60px;
  }

  .selectCandidateCard .titreProperty{
    color:rgba(75, 82, 162, 1);
    font-size:14px;
    font-weight: 400;
    width:100%;
    display:block;
  }
  .selectCandidateCard .valueProperty{
    color:rgba(10, 32, 113, 1);
    font-size:14px;
    font-weight: 700 !important;
    width:100%;
    display:block;
  }

  .footer_link_cc{
 padding-left:20px;
 padding-right:20px;
 margin-bottom:20px;
 margin-top:20px;
  }
  .footer_link_cc a{
      display:block;
      width:100%;
      background:#4c81c0;
      color:#FFF;
      border-radius: 10px;
      padding:10px;
      text-align: center;
  }

  .listOfSelectedStartups{
    margin-top:25px;
  }


  .listOfJudges{
    display:flex;
    gap:20px;
    margin-top:10px;
    flex-wrap: wrap;
  }



  .oneJudgeSelected{
    background:#480C831A;
    color:#480C83;
    padding:5px 20px;
    display:flex;
    gap:10px;
    border-radius: 200px;
    border: 1px solid #480C831A;
    position:relative;
  }
  .subTitleJudge{
    font-size:16px;
    font-weight: 700;
    color:#04246A;
    margin-bottom:10px;
    display:block;
    width:100%;
  }

  .judgesWithLicenses
  {
      padding-top:35px;
  padding-bottom:25px;
  border-bottom: 1px solid #BACFE5;
  }
  .judgesWithoutLicences{
    padding-top:35px;
  padding-bottom:25px;
  border-bottom: 1px solid #BACFE5;
  }

  .oneInfoAboutValue p{
    padding:0;
    margin:0;
  }



  .barcontainer{
    background-color: #DDDDDD;
    position: relative;
    margin-left: 50px;
    width: 30px;
    height: 200px;
  }
  .bar{
    background-color: #3783C5;
    position: absolute;
    bottom: 0;
    width: 100%;

    box-sizing: border-box;
    -webkit-transition: all 0.5s linear;
        -moz-transition: all 0.5s linear;
        -o-transition: all 0.5s linear;
        transition: all 0.5s linear;
    transform-origin: bottom;
  }
  .bar.low{
    height: 10%;
  }
  .bar.medium{
    height: 50%;
  }

  .bar.high{
    height: 90%;

  }

  @keyframes grow{
    from{
      transform: scaleY(0);
    }
  }

  .jauge_label.low{
    position: absolute;
    bottom :10%;
    transform: translateY(50%);
    right: -210px;
    width: 200px;
    padding-left: 10px;
    display: flex;
    align-items: center;
  }

  .jauge_label.medium{
    position: absolute;
    bottom :50%;
    transform: translateY(50%);
    right: -210px;
    width: 200px;
    padding-left: 10px;
    display: flex;
    align-items: center;
  }


  .jauge_label.high{
    position: absolute;
    top :10%;
    transform: translateY(-50%);
    right: -210px;
    width: 200px;
    padding-left: 10px;
    display: flex;
    align-items: center;
  }

  .jauge_label::before{
    content :" ";
    background: #707070;
    width:10px;
    height:1px;
    left: -10px;
    position:absolute;
    top: 50%;
  }
  .jauge_label input{
    width:22px;
    height:22px;
  }

  .jauge_label span{
    display:block;
    color: #3783C5;
    font-size: 14px;
    line-height: 22px;
    width:100%;
    font-weight: 500;
    text-transform:uppercase;
  }
  .jauge_label small{
    color: #575757;
    font-weight: 300;
    font-size:14px;
    line-height: 22px;
  }

  .and{
    width:100%;
    font-weight: bold;
    font-size:30px;
  }

  .jauge_label{
    text-align:left !important;
  }

  .info{
    margin-left:10px;
  }


  .flex{
    display:flex;
    align-items: center;
      gap: 20px;
  }
  .barLabel{
    color: #3783C5;
    font-size:18px;
    line-height: 21px;
  }
  @media screen and (max-width:1200px){
    .flex{
      flex-direction: column;

      align-items: flex-start;
    }
  }

  .startupName{
    font-size:24px;
    font-weight: 700;
    color:#000;
  }

  .keyContact{
    margin-top:25px;
  }

  .startupInfo{
    margin-top:20px;
  }

  .flexRow{
    display:flex;
    flex-wrap: wrap;
    align-items:stretch;
  }
  .flexRow .criterias,
  .flexRow .startup{
    height:100%;
  }
  .actions{
    display:flex;
    flex-wrap: wrap;
    gap:10px;
    justify-content: flex-end;
    width:100%;
    margin-top:50px;
    margin-bottom: 50px;
  }
  .next_step_btn_small{
    background: #3783C5 0% 0% no-repeat padding-box;
    border: 1px solid #3783C5;
    border-radius: 200px;
    opacity: 1;
      padding: 14px 37px;
    color:#FFF;
    margin:5px;
  }

  .prev_step_btn_small{
    color:#3783C5;
    background: #fff 0% 0% no-repeat padding-box;
    border: 1px solid #3783C5;
    border-radius: 200px;
    opacity: 1;
      padding: 14px 37px;
    margin:5px;
  }
  .goBack:hover,
  .goBack{
    display:flex;
    gap:10px;
    align-items: center;
    font-weight: 500;
    color:#000;
    text-decoration: none;
    cursor:pointer;
  }
  .navigationVotes{
    display:flex;
    flex-wrap:wrap;
    justify-content: space-between;
    align-items: center;

  }
  .navigationVotes .list{
    display:flex;
    gap:10px;
    align-items: center;
  }
  .navigationVotes .list img{
    flex:none;
    width:16px;
  }
  .innopearl_input.select3211234{
    width: 300px;
    position:relative;
    z-index:999;
  }
  .innopearl_input.select3211234 select{
  width:100%;
  }
  .innopearl_input.select3211234::after{
      position:absolute;
    top: calc(50% - 11px);
      right:10px;
      z-index:-1;
      content:  url('@/assets/chevronDown.svg');
  }

  .nextStartup img{
    transform:rotate(180deg);
  }
  .one13{
    width: calc(100% / 3);
    display: flex;

  }
  .one13.list{
    justify-content: center;
  }
  .one13:last-child{
    justify-content: flex-end;
  }

  @media screen and (max-width:990px){
    .nextStartup.one13{
      display:none;
    }
    .one13{
      width:50%;
    }
  }

  @media screen and (max-width:990px){
    .one13.nextStartup{
      display:none;
    }
    .criterias{
      margin-top:50px;
    }
  }

  @media screen and (max-width:690px){
    .one13.nextStartup,
    .one13.list{
      display:none;
    }
  }
</style>


<style media="screen">

  .previewNewAssessment .v-slider-thumb__surface.elevation-2{
    border:1px solid #3783C5 !important;
    color: #3783C5 !important;
    background-color: #3783C5 !important;
  caret-color: #3783C5 !important;
  backdrop-filter: blur(40px);

  }
.previewNewAssessment .v-slider-thumb__ripple{
  color:#FFF !important;
    caret-color:#FFF !important;
}
.previewNewAssessment .v-slider{
  margin-top:40px;
}
.previewNewAssessment .v-slider.v-input--horizontal .v-slider-thumb__label::before{
  display:none;
}
.previewNewAssessment .v-slider-thumb__label{
  background: #DFE4F3 !important;
  color: #3783C5 !important;
  border: 1px solid #DFE4F3 !important;
  border-radius: 10px !important;
  font-weight: 500;
}

.previewNewAssessment .v-slider.v-input--horizontal .v-slider-track{
  height:6px !important;
}
.previewNewAssessment .v-slider.v-input--horizontal .v-slider-track__background {
  height:6px !important;
}
.previewNewAssessment  .v-slider.v-input--horizontal .v-slider-thumb__label{
  bottom:10px;
}
.previewNewAssessment .v-slider-track__background{
  background-color: #C4CFEC !important;
  opacity: 1;
}
.previewNewAssessment  .v-slider .v-input__control{
  margin-left:10px;
  margin-right: 10px;
}

</style>
